import { i18n } from "@/setup/i18n-setup";
import { VatDeclarationPeriod } from "./period";

export class VatDeclarationQuarterPeriod extends VatDeclarationPeriod {
	public ForQuarter:number = Math.floor((new Date().getMonth() + 1) / 3);

	public getJSON() {
		return {
			Year: this.Year,
			ForQuarter: this.ForQuarter
		};
	}
	public toString(): string {
		return i18n.t(`common.quarter-period`).toString()+this.ForQuarter;
	}
}